import React from "react";1
import { useSelector } from "react-redux";
import { RootState } from "../../../app/store";
import { ISystemState } from "../../systems/types";
import styles from "./SystemState.module.css";
import { Label } from "../../../components/Typography";
import { useTranslation } from "react-i18next";

export const SystemState: React.FC = () => {
  const { t } = useTranslation("system");

  const systemState = useSelector(
    (state: RootState) => state.systems.selectedSystem?.state
  );

  if (!systemState) {
    return null;
  }

  const stateItems: Array<{ key: keyof ISystemState; label: string }> = [
    { key: "healthy", label: t("healthy") },
    { key: "paused", label: t("paused") },
    { key: "online", label: t("online") },
    { key: "estop", label: t("estop") },
  ];

  return (
    <div className={styles.systemState}>
      {stateItems.map(({ key, label }) => (
        <div key={key} className={styles.stateItem}>
          <div
            className={`${styles.statusIndicator} ${
              systemState[key] ? styles.healthy : styles.unhealthy
            }`}
          />
          <Label>{label}</Label>
        </div>
      ))}
    </div>
  );
};
